import React from 'react'

export const Compare = () => {
  return (
    <div>Compare</div>
  )
}

